module.exports = "/_next/static/videos/buyer-1-f86a56b33930a90b7c6fc60c94ea98b9.mp4";